/* ==========================================================================
   SOULMAT Produktseite – Interaktion (Ersatz für die PageFly-Inline-Skripte)

   Bildet 1:1 die bisherigen Funktionen ab:
   - Variantenauswahl über Radio-Buttons (Modell. / Funktion. / Größe.)
   - Galerie zeigt nur die Medien, deren Alt-Text die aktive Varianten-ID
     enthält (kommaseparierte Liste am Bild)
   - Preis, Ersparnis, Ratenzahlung, Preis pro Nacht, Artikelnummer und die
     Auswahl-Zusammenfassung aktualisieren sich mit
   - Sticky-Leiste oben (Desktop, ab Scrollposition) und unten (Mobil)
   - Info-Modals
   - Sprunglinks „weiter“ / „zur Größenauswahl“
   ========================================================================== */

(function () {
  'use strict';

  var NIGHTS = 30 * 365; // 30 Jahre – Basis für den Preis pro Nacht

  function euro(cents, digits) {
    var fractionDigits = typeof digits === 'number' ? digits : 2;
    return (
      (cents / 100).toLocaleString('de-DE', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }) + ' €'
    );
  }

  function parseIds(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
  }

  /* ------------------------------------------------------------------ */
  /* Modals                                                             */
  /* ------------------------------------------------------------------ */

  function initModals(root) {
    var scope = root || document;

    function close(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function closeAll() {
      scope.querySelectorAll('.sm-modal.is-open').forEach(close);
    }

    scope.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-sm-modal-open]');
      if (opener) {
        event.preventDefault();
        var modal = document.getElementById(opener.getAttribute('data-sm-modal-open'));
        if (!modal) {
          console.warn('[soulmat] Modal nicht gefunden:', opener.getAttribute('data-sm-modal-open'));
          return;
        }
        closeAll();
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = modal.querySelector('.sm-modal__close');
        if (closeBtn) closeBtn.focus();
        return;
      }

      if (event.target.closest('[data-sm-modal-close]')) {
        event.preventDefault();
        closeAll();
        return;
      }

      // Klick auf den Hintergrund schließt das Modal
      if (event.target.classList && event.target.classList.contains('sm-modal')) {
        close(event.target);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Galerie                                                            */
  /* ------------------------------------------------------------------ */

  function Gallery(container) {
    this.container = container;
    this.items = Array.prototype.slice.call(container.querySelectorAll('[data-sm-media]'));
    this.thumbs = Array.prototype.slice.call(container.querySelectorAll('[data-sm-thumb]'));
    this.activeId = null;
    this.bind();
  }

  Gallery.prototype.bind = function () {
    var self = this;
    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.show(thumb.getAttribute('data-sm-thumb'));
      });
    });
  };

  Gallery.prototype.mediaFor = function (variantId) {
    return this.items.filter(function (item) {
      return parseIds(item.getAttribute('data-variant-ids')).indexOf(String(variantId)) !== -1;
    });
  };

  Gallery.prototype.show = function (mediaId) {
    var self = this;
    this.activeId = String(mediaId);

    this.items.forEach(function (item) {
      var isActive = item.getAttribute('data-sm-media') === self.activeId;
      item.classList.toggle('is-active', isActive);
      if (!isActive) {
        var video = item.querySelector('video');
        if (video && !video.paused) video.pause();
      }
    });

    this.thumbs.forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-sm-thumb') === self.activeId ? 'true' : 'false');
    });
  };

  Gallery.prototype.filter = function (variantId) {
    var visible = this.mediaFor(variantId);

    // Fallback: passt kein Bild zur Variante, zeigen wir alle Medien –
    // besser als eine leere Galerie.
    if (!visible.length) visible = this.items;

    var visibleIds = visible.map(function (item) {
      return item.getAttribute('data-sm-media');
    });

    this.thumbs.forEach(function (thumb) {
      thumb.hidden = visibleIds.indexOf(thumb.getAttribute('data-sm-thumb')) === -1;
    });

    if (visibleIds.indexOf(this.activeId) === -1) {
      this.show(visibleIds[0]);
    }
  };

  /* ------------------------------------------------------------------ */
  /* Hauptprodukt                                                        */
  /* ------------------------------------------------------------------ */

  function SoulmatProduct(root) {
    var dataEl = root.querySelector('[data-sm-variant-data]');
    if (!dataEl) {
      console.warn('[soulmat] Variantendaten fehlen – Produktlogik wird übersprungen.');
      return;
    }

    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.warn('[soulmat] Variantendaten sind ungültig:', error);
      return;
    }

    this.root = root;
    this.optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-option-input]'));
    this.idInputs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-variant-id]'));
    this.galleries = Array.prototype.slice
      .call(root.querySelectorAll('[data-sm-gallery]'))
      .map(function (el) {
        return new Gallery(el);
      });

    this.current = null;
    this.bind();
    this.update({ pushUrl: false });
  }

  SoulmatProduct.prototype.bind = function () {
    var self = this;

    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        self.update({ pushUrl: true });
      });
    });

    // Menge aus dem sichtbaren Feld in alle Formulare spiegeln
    var quantity = this.root.querySelector('[data-sm-quantity]');
    var mirrors = this.root.querySelectorAll('[data-sm-quantity-mirror]');
    if (quantity && mirrors.length) {
      var syncQuantity = function () {
        var value = Math.max(1, parseInt(quantity.value, 10) || 1);
        mirrors.forEach(function (input) {
          input.value = value;
        });
      };
      quantity.addEventListener('input', syncQuantity);
      quantity.addEventListener('change', syncQuantity);
      syncQuantity();
    }

    this.root.querySelectorAll('[data-sm-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById(link.getAttribute('data-sm-scroll-to'));
        if (!target) return;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 75,
          behavior: 'smooth'
        });
      });
    });
  };

  SoulmatProduct.prototype.selectedOptions = function () {
    var selected = [];
    this.optionInputs.forEach(function (input) {
      if (!input.checked) return;
      selected[parseInt(input.getAttribute('data-sm-option-position'), 10) - 1] = input.value;
    });
    return selected;
  };

  SoulmatProduct.prototype.findVariant = function () {
    var selected = this.selectedOptions();
    return (
      this.variants.filter(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      })[0] || null
    );
  };

  SoulmatProduct.prototype.update = function (options) {
    var settings = options || {};
    var variant = this.findVariant();

    this.current = variant;
    this.renderAvailability(variant);
    this.renderPrices(variant);
    this.renderSummary(variant);
    this.renderGalleries(variant);

    this.idInputs.forEach(function (input) {
      input.value = variant ? variant.id : '';
      input.disabled = !variant;
    });

    if (settings.pushUrl && variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    this.root.dispatchEvent(
      new CustomEvent('soulmat:variant:change', { bubbles: true, detail: { variant: variant } })
    );
  };

  SoulmatProduct.prototype.renderAvailability = function (variant) {
    var available = !!(variant && variant.available);
    var label = available ? 'In den Warenkorb' : 'Nicht verfügbar';

    this.root.querySelectorAll('[data-sm-atc]').forEach(function (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      var text = button.querySelector('[data-sm-atc-text]') || button;
      text.textContent = label;
    });
  };

  SoulmatProduct.prototype.renderPrices = function (variant) {
    if (!variant) return;

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var savings = onSale ? variant.compare_at_price - variant.price : 0;

    this.root.querySelectorAll('[data-sm-price-block]').forEach(function (block) {
      block.classList.toggle('sm-price--on-sale', !!onSale);

      var compare = block.querySelector('[data-sm-price-compare]');
      if (compare) {
        compare.textContent = onSale ? euro(variant.compare_at_price) : '';
        compare.hidden = !onSale;
      }

      var current = block.querySelector('[data-sm-price-current]');
      if (current) current.textContent = euro(variant.price);

      var savingsLabel = block.querySelector('[data-sm-price-savings-label]');
      if (savingsLabel) savingsLabel.hidden = !onSale;

      var savingsValue = block.querySelector('[data-sm-price-savings]');
      if (savingsValue) {
        savingsValue.textContent = onSale ? euro(savings) : '';
        savingsValue.hidden = !onSale;
      }

      var perNight = block.querySelector('[data-sm-price-per-night]');
      if (perNight) {
        perNight.textContent = '= ' + euro(variant.price / NIGHTS) + ' / Nacht · 30 Jahre';
      }
    });

    // Ratenzahlung: Preis × 1,1479 auf 24 Monate (PayPal-Ratenkauf)
    this.root.querySelectorAll('[data-sm-installment]').forEach(function (el) {
      el.textContent = euro((variant.price * 1.1479) / 24);
    });
  };

  SoulmatProduct.prototype.renderSummary = function (variant) {
    if (!variant) return;

    var map = {
      sku: variant.sku || '',
      'option-1': variant.options[0] || '',
      'option-2': variant.options[1] || '',
      'option-3': variant.options[2] || ''
    };

    this.root.querySelectorAll('[data-sm-summary]').forEach(function (el) {
      var key = el.getAttribute('data-sm-summary');
      if (key in map) el.textContent = map[key];
    });
  };

  SoulmatProduct.prototype.renderGalleries = function (variant) {
    if (!variant) return;
    this.galleries.forEach(function (gallery) {
      gallery.filter(variant.id);
    });
  };

  /* ------------------------------------------------------------------ */
  /* Protector Cross-Sell                                               */
  /* ------------------------------------------------------------------ */

  function initProtector(root) {
    var select = root.querySelector('[data-sm-protector-select]');
    var idInput = root.querySelector('[data-sm-protector-id]');
    var priceEl = root.querySelector('[data-sm-protector-price]');
    var button = root.querySelector('[data-sm-protector-atc]');
    if (!select) return;

    function sync() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (idInput) idInput.value = option.value;
      if (priceEl && option.dataset.price) priceEl.textContent = euro(parseInt(option.dataset.price, 10));
      if (button) {
        var available = option.dataset.available === 'true';
        button.disabled = !available;
        var text = button.querySelector('[data-sm-protector-atc-text]') || button;
        text.textContent = available ? '+ hinzufügen' : 'Nicht verfügbar';
      }
    }

    select.addEventListener('change', sync);
    sync();
  }

  /* ------------------------------------------------------------------ */
  /* Sticky-Leiste oben (Desktop)                                       */
  /* ------------------------------------------------------------------ */

  function initStickyTop(root) {
    var bar = root.querySelector('[data-sm-sticky-top]');
    var trigger = root.querySelector('[data-sm-sticky-trigger]');
    if (!bar) return;

    // Warenkorb-Icon aus dem Theme-Header übernehmen
    var cartSlot = bar.querySelector('[data-sm-cart-slot]');
    var cartOriginal = document.querySelector('#cart-icon-bubble');
    if (cartSlot && cartOriginal) {
      var cartCopy = cartOriginal.cloneNode(true);
      cartCopy.removeAttribute('id'); // doppelte IDs im Dokument vermeiden
      cartSlot.appendChild(cartCopy);
    }

    var threshold = 0;

    function measure() {
      var reference = trigger || root;
      threshold = reference.getBoundingClientRect().top + window.scrollY + 150;
    }

    function onScroll() {
      if (window.innerWidth <= 990) {
        bar.classList.remove('is-visible');
        return;
      }
      bar.classList.toggle('is-visible', window.scrollY > threshold);
    }

    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      onScroll();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Sticky-Leiste unten (Mobil) – Platz im Body freihalten             */
  /* ------------------------------------------------------------------ */

  function initStickyBottom(root) {
    if (!root.querySelector('[data-sm-sticky-bottom]')) return;
    document.body.classList.add('sm-has-sticky-bar');
  }

  /* ------------------------------------------------------------------ */
  /* Start                                                              */
  /* ------------------------------------------------------------------ */

  function init() {
    var root = document.querySelector('[data-sm-product]');
    if (!root) return;

    new SoulmatProduct(root);
    initProtector(root);
    initStickyTop(root);
    initStickyBottom(root);
    initModals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
